// import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import MainSection from "../../components/mainLayout/Main";
// import { DatePicker, Space } from "antd";
import { addAlert } from "../../redux/actions/authActions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";




function CreateAlert() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // FIX: Key name changed from 'alert' to 'content'
  const [formData, setFormData] = useState({
    content: "", 
    description: "",
  });

  const onChange = (e) => {
    // Note: use e.target.id to match the 'id' attribute of your textareas
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (formData.content.length < 5) {
        return alert("Content must be at least 5 characters");
      }
      
      // This will now send { content: "...", description: "..." }
      await dispatch(addAlert(formData)); 
      navigate("/notifications");
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      // The loading state is handled in the Redux catch block below
    }
  };

  return (
    <div>
      <Sidebar />
      <MainSection>
        <SectionHeader title="Create Alert" />
        <form onSubmit={handleSubmit}>
          <div className="container w-full md:w-1/2 lg:w-1/3 text-start">
            <div className="my-5">
              <label className="block mb-2 text-sm font-medium text-gray-900">
                Alert Content
              </label>
              <textarea
                id="content" // FIX: id must match the key in formData
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                placeholder="Add Alert Content"
                value={formData.content} // FIX: use formData.content
                onChange={onChange}
                required
              />
            </div>
            <div className="my-5">
              <label className="block mb-2 text-sm font-medium text-gray-900">
                Alert Description
              </label>
              <textarea
                id="description"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                placeholder="Add Alert Description"
                value={formData.description}
                onChange={onChange}
                required
              />
            </div>
            <button
              type="submit"
              className="w-full flex justify-center py-2 px-4 rounded-full text-white bg-[#045B9B] hover:bg-[#3385c0]"
            >
              Add Alert
            </button>
          </div>
        </form>
      </MainSection>
    </div>
  );
}   
export default CreateAlert;